import { Children, forwardRef } from 'react';
import { DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import { Card } from '../Card';
import { Input } from '../Input';
import type { MenuProps } from './Menu';
import { Menu } from './Menu';
import { MenuItem } from './MenuItem';
import { Button } from '../Button';
import { CheckboxMenuItem } from './CheckboxMenuItem';

export type FilterMenuProps = MenuProps & {
  /**
   * The selected values of the filter Menu
   * */
  value: string[];
  /**
   * Callback for when the selected values change
   */
  onChange: (value: string[]) => void;
  /**
   * The current search value
   */
  searchValue: string;
  /**
   * Callback for when the search value changes (by searching the input)
   */
  onSearchValueChange: (value: string) => void;
};

export const FilterMenuItem = CheckboxMenuItem;

export const FilterMenu = forwardRef<HTMLButtonElement, FilterMenuProps>(
  (
    { value, onChange, searchValue, onSearchValueChange, children, ...props }: FilterMenuProps,
    ref,
  ) => {
    return (
      <Menu
        {...props}
        ref={ref}
      >
        <Card
          alignItems="flex-end"
          border={false}
          borderRadius="border-radius-02"
          paddingSize="space-01"
          prominence="primary"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            margin: '1px',
          }}
        >
          <Input
            autoFocus={true}
            onChange={(event) => {
              onSearchValueChange(event.target.value);
            }}
            onKeyDown={(event) => {
              if (event.key === 'ArrowDown') {
                event.preventDefault();
                const menu = document.querySelector('[role="menu"]');
                const firstMenuItem = menu?.querySelector('[role="menuitemcheckbox"]');
                if (firstMenuItem) {
                  (firstMenuItem as HTMLElement).focus();
                }
              }

              event.stopPropagation();
            }}
            placeholder="Search..."
            tabIndex={0}
            type="search"
            value={searchValue}
          />
        </Card>
        <MenuItem
          disabled={true}
          style={{ padding: '16px' }}
        >
          {' '}
        </MenuItem>
        {Children.toArray(children).length > 0 ? (
          children
        ) : (
          <MenuItem disabled={true}>No results found</MenuItem>
        )}
        {value.length > 0 && (
          <DropdownMenuItem
            disabled={true}
            style={{ marginTop: '24px' }}
          >
            <Card
              alignItems="flex-end"
              border={false}
              borderRadius="border-radius-02"
              paddingSize="space-01"
              prominence="primary"
              style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                margin: '1px',
              }}
            >
              <Button
                onClick={() => onChange([])}
                size="sm"
              >
                Clear
              </Button>
            </Card>
          </DropdownMenuItem>
        )}
      </Menu>
    );
  },
);

FilterMenu.displayName = 'FilterMenu';
